var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9",
    "data-name": "Group 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.091,
    height: 23.644,
    viewBox: "0 0 25.091 23.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1466.777,987.362h-13.032a6.037,6.037,0,0,1-6.03-6.03V969.748a6.036,6.036,0,0,1,6.03-6.03h13.032a6.035,6.035,0,0,1,6.029,6.03v11.584A6.036,6.036,0,0,1,1466.777,987.362ZM1453.745,966a3.748,3.748,0,0,0-3.745,3.744v11.584a3.749,3.749,0,0,0,3.745,3.745h13.032a3.749,3.749,0,0,0,3.744-3.745V969.748a3.749,3.749,0,0,0-3.744-3.744Z",
    transform: "translate(-1447.715 -963.718)",
    fill: "#6A6975"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1462.77,983.4a6.044,6.044,0,1,1,6.044-6.043A6.051,6.051,0,0,1,1462.77,983.4Zm0-9.8a3.759,3.759,0,1,0,3.759,3.76A3.764,3.764,0,0,0,1462.77,973.6Z",
    transform: "translate(-1449.862 -965.528)",
    fill: "#6A6975"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.93,
    cy: 0.93,
    r: 0.93,
    transform: "translate(17.898 4.285)",
    fill: "#6A6975"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkInstagram);
export default __webpack_public_path__ + "static/media/dark-instagram.513ad577.svg";
export { ForwardRef as ReactComponent };